<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    active-color="#7e5678"
    :border="true"
    inactive-color="#979799"
    z-index="999"
  >
  <!-- 首页 -->
    <van-tabbar-item to="/Home">
      <span>{{ $t("foorter.index") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/indexed.png' : '/img/footer/index.png'"
          :alt="$t('foorter.index')"
          v-show="show !== 0"
        />
        <img
          :src="props.active ? '/img/footer/indexed.png' : '/img/footer/index.png'"
          :alt="$t('foorter.index')"
          :class="$t('foorter.index')"
          style="height: 4rem"
          v-show="show === 0"
        />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/Lists">
      <span>{{ $t("shenshi") }} </span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/aixs.png' : '/img/footer/aix.png'"
          :alt="$t('shenshi')"
          v-show="show !== 1"
        />
        <img
          :src="props.active ? '/img/footer/aixs.png' : '/img/footer/aix.png'"
          :alt="$t('shenshi')"
          style="height: 4rem"
          v-show="show === 1"
        />
      </template>
    </van-tabbar-item>
    <van-tabbar-item to="/Listss">
      <span>{{ $t('jiaren') }} </span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/aixs.png' : '/img/footer/aix.png'"
          :alt="$t('jiaren')"
          v-show="show !== 2"
        />
        <img
          :src="props.active ? '/img/footer/aixs.png' : '/img/footer/aix.png'"
          :alt="$t('jiaren')"
          style="height: 4rem"
          v-show="show === 2"
        />
      </template>
    </van-tabbar-item>
    
    <!-- 影院 -->
    <!-- <van-tabbar-item to="/Video">
      <span>{{ $t("foorter.subscribe") }} </span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/yingyuaned.png' : '/img/footer/yingyuan.png'"
          :alt="$t('foorter.subscribe')"
          v-show="show !== 1"
        />
        <img
          :src="props.active ? '/img/footer/yingyuaned.png' : '/img/footer/yingyuan.png'"
          :alt="$t('foorter.subscribe')"
          :class="$t('foorter.subscribe')"
          style="height: 4rem"
          v-show="show === 1"
        />
      </template>
    </van-tabbar-item> -->

    <!-- 视频 -->
    <!-- <van-tabbar-item to="/Choose">
      <span>{{ $t("foorter.xuanfei") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/xuanfeied.png' : '/img/footer/xuanfei.png'"
          :alt="$t('foorter.xuanfei')"
          v-show="show !== 2"
        />
        <img
         :src="props.active ? '/img/footer/xuanfeied.png' : '/img/footer/xuanfei.png'"
          :alt="$t('foorter.xuanfei')"
          :class="$t('foorter.xuanfei')"
          style="height: 4rem"
          v-show="show === 2"
        />
      </template>
    </van-tabbar-item> -->
    <van-tabbar-item to="/Lottery">
      <span>{{ $t("foorter.video") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/toupiaoed.png' : '/img/footer/toupiao.png'"
          :alt="$t('foorter.video')"
          v-show="show !== 3"
        />
        <img
         :src="props.active ? '/img/footer/toupiaoed.png' : '/img/footer/toupiao.png'"
          :alt="$t('foorter.video')"
          :class="$t('foorter.video')"
          style="height: 4rem"
          v-show="show === 3"
        />
      </template>
    </van-tabbar-item>
    <!-- 我的 -->
    <van-tabbar-item to="/Mine">
      <span>{{ $t("foorter.my") }}</span>
      <template #icon="props">
        <img
          :src="props.active ? '/img/footer/myed.png' : '/img/footer/my.png'"
          :alt="$t('foorter.my')"
          v-show="show !== 4"
        />
        <img
          :src="props.active ? '/img/footer/myed.png' : '/img/footer/my.png'"
          :alt="$t('foorter.my')"
          :class="$t('foorter.my')"
          style="height: 4rem"
          v-show="show === 4"
        />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0
    };
  },
  methods: {
    // 提取路由匹配逻辑为公共方法，避免冗余
    setTabbarStatus(routeName) {
      // 容错：routeName 为空时直接隐藏
      if (!routeName) {
        this.show = false
        return
      }

      // 路由与 active 映射关系（对象配置，更简洁，方便后续扩展）
      const routeActiveMap = {
        home: 0,
        lists: 1,
        listss:2,
        // choosse: 2,
        lottery: 3, // lottery 和 choose 共用 active: 2
        mine: 4
      }

      // 判断是否在导航匹配列表中
      const targetActive = routeActiveMap[routeName.toLowerCase()]
      if (targetActive !== undefined) {
        this.active = targetActive
        this.show = true
      } else {
        this.show = false
      }
    }
  },
  watch: {
    // 监听路由变化，更新导航状态
    $route(to) {
      this.setTabbarStatus(to.name)
    }
  },
  created() {
    // 组件创建时，初始化导航状态（复用公共方法，避免冗余）
    this.setTabbarStatus(this.$route.name)
  }
};
</script>

<style lang="less" scoped>
@tabbar-height: 110px;
@tabbar-img: 75px;
.van-tabbar {
  height: @tabbar-height;
}
.van-tabbar-item__icon img {
  height: 8vw;
}
.van-tabbar-item {
  font-size: 26px;
}
.tui {
  width: 4rem;
  height: 4rem!important;
  margin-top: -7.333vw;
  background-color: white;
  border-radius: 50%;
  border: 10px solid white;
  z-index: 10;
}
[class*="van-hairline"]::after {
  border: none !important;
}
</style>
